<form class="aeg-u-bg-alt aeg-u-box-padding ">
    <div class="aeg-u-bg-white aeg-u-box-padding">
        <div class="aeg-flex-rows-layout">
            <div class="aeg-flex-row">
                <div class="aeg-label-above-layout">
                    <label for="transaction-id">Transaction Id</label>
                    <InputText id="transaction-id" name="transaction-id" v-model="transactionId" autocomplete="off" />
                </div>
            </div>
            <div class="aeg-flex-row">
                <div class="aeg-label-above-layout">
                    <label for="date-from">Van</label>
                    <DatePicker show-icon show-time hide-on-date-time-select v-model="dateFrom" id="date-from"/>
                </div>
                <div class="aeg-label-above-layout">
                    <label for="date-to">Tot en met</label>
                    <DatePicker show-icon show-time hide-on-date-time-select v-model="dateTo" id="date-to"/>
                </div>
            </div>
            <div class="aeg-flex-row">
                <div class="aeg-label-above-layout">
                    <label for="status" class="flex flex-row items-center">Status <aeg-session-status-popover /></label>
                    <Select id="status" name="status" :options="sessionStateOptions" option-label="label" option-value="value" v-model="selectedState" />
                </div>
                <div class="aeg-label-above-layout">
                    <label for="session-type">Soort sessie</label>
                    <Select id="session-type" name="session-type" :options="sessionTypeOptions" option-label="label" option-value="value" v-model="selectedSessionType" />
                </div>
                <div class="aeg-label-above-layout">
                    <label for="paymentMethod">Betaalmethode</label>
                    <Select id="paymentMethod" name="paymentMethod" :options="paymentMethodOptions" option-label="label" option-value="value" v-model="selectedPaymentMethod">
                    </Select>
                </div>
                <div class="aeg-label-above-layout">
                    <label for="service-type">Service</label>
                    <Select id="service-type" name="service-type" :options="serviceTypeOptions" option-label="label" option-value="value" v-model="selectedServiceType">
                    </Select>
                </div>
            </div>
            <div class="aeg-flex-row">
                <div class="aeg-label-above-layout">
                    <label for="actor-identifier">Identificator (KBO, OVO, OrgCode of SubjectId)</label>
                    <InputText name="actor-identifier" id="actor-identifier" v-model="actorIdentifier" autocomplete="off" />
                </div>
                <div class="aeg-label-above-layout">
                    <label for="actor">Actor</label>
                    <InputText name="actor" id="actor" v-model="actorName" autocomplete="off" />
                </div>
            </div>
            <div class="aeg-flex-row">
                <div class="aeg-label-above-layout">
                    <label for="sessionDetail">Sessiedetails</label>
                    <InputText name="sessionDetail" id="sessionDetail" v-model="sessionDetail" autocomplete="off" />
                </div>
                <div class="aeg-label-above-layout">
                    <label for="documentNumber">Documentnummer</label>
                    <InputText name="documentNumber" id="documentNumber" v-model="documentNumber" autocomplete="off" />
                </div>
            </div>
        </div>
    </div>
</form>
